<template>
  <b-modal
    id="confirm-dialog"
    :visible="!!request"
    hide-header
    hide-footer
    centered
    dialog-class="tw-w-[calc(100%-1rem)] tw-max-w-[480px] tw-mx-auto"
    content-class="tw-rounded-[14px] tw-border-0"
    body-class="tw-p-7"
    :no-close-on-backdrop="loading || !options.backdropClose"
    no-close-on-esc
    @hide="onHide"
  >
    <div v-if="request" data-testid="confirm-dialog">
      <h5 class="tw-text-[1.05rem] tw-font-bold tw-text-gray-700 tw-mb-2.5">{{ request.title }}</h5>
      <div v-if="options.html" class="tw-text-[0.82rem] tw-leading-relaxed tw-text-gray-500" data-testid="confirm-dialog-body" v-html="request.body"/>
      <p v-else-if="request.body" class="tw-text-[0.82rem] tw-leading-relaxed tw-text-gray-500" data-testid="confirm-dialog-body">{{ request.body }}</p>
      <div class="tw-flex tw-gap-2 tw-pt-3">
        <b-button variant="light" :class="buttonClass" :disabled="loading" data-testid="confirm-dialog-cancel" @click="cancel">
          {{ options.cancelText || $t('cancel') }}
        </b-button>
        <b-button variant="primary" :class="buttonClass" :disabled="loading" data-testid="confirm-dialog-ok" @click="ok">
          <b-spinner v-if="loading" small class="tw-mr-1"/>
          {{ options.okText }}
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import {closeConfirm, confirmState} from "@components/global/confirm";

export default {
  name: 'ConfirmDialog',
  data() {
    return {
      buttonClass: 'tw-text-[0.82rem] tw-font-semibold tw-rounded-lg tw-px-[1.1rem] tw-py-[0.55rem]',
    };
  },
  mounted() {
    document.addEventListener('keydown', this.onKeydown, true);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.onKeydown, true);
  },
  computed: {
    request() {
      return confirmState.request;
    },
    loading() {
      return confirmState.loading;
    },
    options() {
      return this.request ? this.request.options : {};
    },
  },
  watch: {
    // A redirect away (paused or expired account) would leave a spinning loader dialog over the new page.
    '$route.path'() {
      if (this.request) this.cancel();
    },
  },
  methods: {
    ok() {
      const { request } = this;
      if (request.options.loader) confirmState.loading = true;
      else closeConfirm();
      request.resolve();
    },
    cancel() {
      const { request } = this;
      closeConfirm();
      request.reject();
    },
    // A backdrop click counts as cancel; closing it from code (request gone) doesn't
    onHide() {
      if (this.request) this.cancel();
    },
    // Esc is handled here rather than by b-modal, which only hears it while focus is inside:
    // a backdrop click on a dialog that stays open moves focus to the page. Capturing it first
    // means the Esc that opens a confirmation (a modal's discard prompt) doesn't also close it,
    // and stopping it means one Esc closes only the confirmation, not the modal beneath.
    onKeydown(event) {
      if (event.key !== 'Escape' || !this.request || this.loading) return;
      event.stopPropagation();
      this.cancel();
    },
  },
};
</script>

<style>
/* Above the side panels (1060), which raise confirmations of their own. */
#confirm-dialog___BV_modal_outer_ {
  z-index: 1080 !important;
}
</style>
